import clsx from 'clsx';

/**
 * Visual inheritance status for a variant field. See variantInheritance.js for
 * the pure helpers that decide whether a field is inherited or overridden.
 */

function Pill({ tone, children }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium',
        tone === 'accent'
          ? 'bg-accent/15 text-accent ring-1 ring-inset ring-accent/30'
          : 'bg-border/40 text-ink-muted ring-1 ring-inset ring-border'
      )}
    >
      {children}
    </span>
  );
}

/**
 * Inline inheritance status for a single variant field. Renders nothing unless
 * the field is inheritable and the base actually holds a value (`show`). When
 * the variant's own value is empty it shows the "inherited" pill plus a muted
 * preview of the base content; once overridden, it shows the "modified" pill.
 */
export function InheritStatus({ show, empty, preview, className }) {
  if (!show) return null;
  return (
    <div className={clsx('mt-1.5 flex flex-wrap items-center gap-2 text-xs', className)}>
      {empty ? (
        <>
          <Pill tone="muted">Ereditato dal base</Pill>
          {preview != null && preview !== '' && (
            <span className="min-w-0 truncate text-ink-faint" title={typeof preview === 'string' ? preview : undefined}>
              {preview}
            </span>
          )}
        </>
      ) : (
        <Pill tone="accent">Modificato sulla variante</Pill>
      )}
    </div>
  );
}
